import React, { useEffect, useState } from 'react'
import {useHistory } from 'react-router-dom';
import { useRef } from "react";
import {
    FormContainer,
    AuthBgContainer,
    PageLinkTextNoLink, PageTitleText
} from './../sign_in/sign_in.style';
import {
    AppInputField,InputFieldTitleText,AppInputFieldBtn
} from '../../../widget/styledComponents/input_field.style'

import { gql, useMutation } from '@apollo/client';
import AppLogo from '../../../widget/app_logo';
import { toaster } from 'evergreen-ui';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useAuth } from '../../../../context/AuthContext';
import Cookies from 'js-cookie';


export const SUB_ADMIN_CREATE_PASSWORD = gql`
mutation FacilityManager_activateSubAdminAccount($token: String!, $password: String!) {
  facilityManager_activateSubAdminAccount(token: $token, password: $password) {
    code
    success
    error
    token
  }
}
`;

function ActivateSubAdminWidget() {
const { id } = useParams();

const history = useHistory()
const [addTodo, { loading }] = useMutation(SUB_ADMIN_CREATE_PASSWORD);

const handleSubmit=(e)=>{
    e.preventDefault()
    addTodo({
      variables: { 
        token: id,
        password: passwordRef.current.value,
      },
    })
    .then((response) => {
      toaster.notify("Your password was set susccesfully")
      history.push(`/`);
    })
    .catch((error) => {
      toaster.danger(error.message)
    });
  }

const passwordRef = useRef(null);


const [showPass,setShowPass] = useState(false)
const clearAllCookies = () => {
    const cookies = Object.keys(Cookies.get());
    cookies.forEach(cookie => Cookies.remove(cookie));
  };
const {logout} = useAuth()

useEffect(() => {
    logout();
    clearAllCookies()
    Cookies.remove('userAccessToken');

  return () => {
    
  }
}, [logout])


  return (
    <div className='row'>
        <AuthBgContainer className="col s12 m6 l6 hide-on-med-and-down"></AuthBgContainer>
        <div className='col s12 m6 l6 '>
            <div className='mt-100'></div>
            <form onSubmit={handleSubmit}>
            <FormContainer >
               
                <div className='right'>
                    <AppLogo/>
                </div>
                <br/><br/>
                <PageTitleText>
                    <small>Create your prefered password</small>
                </PageTitleText>
                <br/>
               
                <InputFieldTitleText>
                    Password
                </InputFieldTitleText>
                <AppInputField
                    type= {showPass?'text':'password' }
                    ref={passwordRef}
                /> 
                <div className='col s12 right'>
                    <PageLinkTextNoLink className='right' style={{
                    color:"var(--black, #4F46E5) !important",fontSize:"12px",
                    }} onClick={()=>setShowPass(!showPass)}>{showPass?'Hide':'Show'}</PageLinkTextNoLink >
                </div>
                
               
                <AppInputFieldBtn className="mt-50"
                      type='submit'
                      disabled={loading} 
                  >
                    {!loading && 'Create password' } 
                    {loading && 'Loading' } 
                </AppInputFieldBtn>
                
               
                

            </FormContainer>
            </form>

        </div>
    </div>
  )
}

export default ActivateSubAdminWidget

